import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import { BookingProvider } from "./BookingContext";
import Privacy from "./pages/Privacy";
import PreviewMock from "./pages/PreviewMock";
import ScrollDemoMock from "./pages/ScrollDemoMock";
import ScrollDemoMock2 from "./pages/ScrollDemoMock2";
import OgPreviewMock from "./pages/OgPreviewMock";
import OgFinal from "./pages/OgFinal";
import AreasWeServe from "./pages/AreasWeServe";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <I18nProvider>
        <BookingProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<PreviewMock />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/areas-we-serve" element={<AreasWeServe />} />
              <Route path="/scroll-mock" element={<ScrollDemoMock />} />
              <Route path="/scroll-mock-2" element={<ScrollDemoMock2 />} />
              <Route path="/og-preview-mock" element={<OgPreviewMock />} />
              <Route path="/og-final" element={<OgFinal />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors closeButton />
        </BookingProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
